import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import './loader.styl'

export const Loader = ({isLoading = false}) => {
    return(
        <>
            { isLoading &&
                <Box className="box">
                  <CircularProgress className="progress" />
                </Box>
            }
        </>
    )
}